
import React, { PureComponent } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import AuditInfo from '../../../dossiers/common/audit/AuditInfo'

class AuditFleetModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate () {
  }

  render () {
    const {
      t, showModal,
      actions: { refreshAuditFleetInfo, auditFleetInfoDownload }, auditInfo
    } = this.props
    return (
      <div id="auditFleetModal">
        <Col sm={12} className="col-row">
          <Row className="inputs-wrapper flexRow justifyEnd">
            <Button
              onClick={() => auditFleetInfoDownload(this.props.fleet.fleetId)}
              className="_Btn accept inv">
              <i className="iDocIcon-download" />
              {t('SEARCH.ACTIONS.EXPORT')}
            </Button>
          </Row>
          { showModal && <AuditInfo
            auditInfo={auditInfo}
            dossierType={this.props.fleet.dossierSubType}
            actions={{ refreshAuditFleetInfo }}
            t={t}
            isFleetAudit={true}
            fleetId={this.props.fleet.fleetId}
            tabActiveKey={this.props.tabActiveKey}
          />}
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'auditFleetModal'
})(AuditFleetModal)
